export default __webpack_public_path__ + "static/media/IMG_0436.aec68dfd.jpg";